import { formatMentionTiming } from "@/utils";

export default function DurationDisplay({
  lengthSeconds,
}: {
  lengthSeconds: number;
}) {
  return (
    <p className="text-xs text-muted-foreground tabular-nums font-semibold">
      {formatMentionTiming(lengthSeconds)}
    </p>
  );
}
